import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "@nxt-shared/ui/lib/utils";
import { LiveBlogWordmark } from "./LiveBlogLogo.js";
import { NxtLogo } from "./NxtLogo.js";
import { PRODUCT_LABEL } from "./switcherModel.js";
/**
 * A product's wordmark, "LIVE BLOG" or "NXT", as high as `className` makes the box (20px by default).
 * Announced as the product's name, so a row needs no separate product label for assistive technology.
 */
export function ProductLogo({ product, className }) {
    return (_jsx("span", { role: "img", "aria-label": PRODUCT_LABEL[product], className: cn("inline-flex h-5 shrink-0 items-center", className), children: product === "nxt" ? _jsx(NxtLogo, { tight: true, className: "h-full w-auto" }) : _jsx(LiveBlogWordmark, { className: "h-full w-auto" }) }));
}
//# sourceMappingURL=ProductLogo.js.map